import Toggle from '../Utilities/Toggle';

export default function Doc2uToggle(props) {
    return(
        <div className={"doc2u-toggle capteur-show capteur-role-Doc2u"}>
            <span className="doc2u-toggle__title">Doc2U</span>
            <Toggle className={`doc2u-toggle__toggle`} status={props.status} onClick={props.onClick} />
        </div>
    );
}
